import { StarIcon } from '../../../assets/icons/StarIcon';
import ConfirmationUpsellBackground from './ConfirmationUpsellBackground.png';
import { Button } from '@domgen/base-design-system-2.0/atoms/Button';
import { useTranslation } from 'react-i18next';

const styles = {
  container:
    'relative flex items-center justify-center w-screen p-space-500 md:p-space-700 overflow-hidden bg-cover bg-center md:w-186.5 md:rounded-lg',
  overlay: 'absolute inset-0 bg-[rgba(0,0,0,0.20)]',
  panel:
    'relative z-10 flex flex-wrap items-start w-full rounded-lg bg-bg-main-container p-space-500 gap-space-400',
  star: {
    container:
      'relative flex items-center justify-center text-center w-[min(110px,25vw)] h-[min(110px,25vw)] md:w-35 md:h-35',
    offerText:
      'absolute inset-0 flex items-center justify-center text-body-strong sm:text-body-large-strong text-neutral-0 pointer-events-none px-space-300',
  },
};

type ConfirmationUpsellPanel = {
  applianceName: string;
  discountPaymentAmount: number;
  discountPaymentType?: 'cc' | 'ach';
  discountTerm?: number;
  discountPercentage?: number;
  handleCheckoutNavigation: () => void;
};
export const ConfirmationUpsellPanel = (props: ConfirmationUpsellPanel) => {
  const {
    applianceName,
    discountPaymentAmount,
    discountPaymentType,
    discountTerm,
    discountPercentage,
    handleCheckoutNavigation,
  } = props;

  const { t } = useTranslation('confirmationPage', { keyPrefix: 'upsell' });

  const offer = () => {
    const achMarker = discountPaymentType === 'ach' ? '*' : '';
    return t('discountOffer', {
      percentage: discountPercentage,
      months: discountTerm,
      marker: achMarker,
    }).toUpperCase();
  };
  const hasDiscount = discountPaymentType && discountPercentage && discountTerm;

  const navigateToCheckout = () => {
    handleCheckoutNavigation();
  };

  const discountPaymentAmountFormat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <article
      data-testid="confirmation-upsell-panel"
      className={styles.container}
      style={{
        backgroundImage: `url(${ConfirmationUpsellBackground})`,
        backgroundPosition: 'right bottom',
      }}
    >
      <div className={styles.overlay} aria-hidden />
      <div className={styles.panel}>
        <div className="flex flex-col gap-space-200 flex-1 min-w-0">
          <div className="flex items-start gap-space-400">
            <h5 className="flex-1 text-h4 text-left text-neutral-900">
              {t('protectAppliance', {
                applianceName,
                amount: discountPaymentAmountFormat.format(discountPaymentAmount),
              })}
            </h5>
            {hasDiscount && (
              <div className={`${styles.star.container} md:hidden`}>
                <StarIcon />
                <p className={`${styles.star.offerText}`}>{offer()}</p>
              </div>
            )}
          </div>

          <p className="text-body">{t('reassurance')}</p>
          {discountPaymentType === 'ach' && <p className="text-body">{t('bankAccountDiscount')}</p>}
          <div className="md:w-fit">
            <Button onClick={navigateToCheckout}>{t('checkout')}</Button>
          </div>
        </div>
        {hasDiscount && (
          <div className={`${styles.star.container} hidden md:flex`}>
            <StarIcon />
            <p className={`${styles.star.offerText}`}>{offer()}</p>
          </div>
        )}
      </div>
    </article>
  );
};
